<template>
  <div id="app">
    <SemcogHeader>
      <span class="title" style="line-height: 2em; font-size: 1em;">
        Transportation Access to Core Services
      </span>
      <span v-if="!jobColumn" class="dynamic-title" style="line-height: 2em; font-size: 1em;">
        {{ modeNames[data_table].name }} Access to {{ amenityNames[mappedAmenity] }}
      </span>
      <span v-if="jobColumn" class="dynamic-title" style="line-height: 2em; font-size: 1em;">
        Number of {{ jobColumnNames[jobColumn] }} by {{ modeNames[data_table].name }} Mode
      </span>
    </SemcogHeader>
    <mainmap
        v-bind:data_table="data_table"
        v-bind:data_tables="data_tables"
        v-bind:mappedAmenity="mappedAmenity"
        v-bind:destLookup="destLookup"
        v-bind:amenities="amenities"
        v-bind:counties="counties"
        v-bind:mcd="mcd"
        v-bind:modeNames="modeNames"
        v-bind:amenityNames="amenityNames"
        v-bind:demographicColumns="demographicColumns"
        v-bind:demographicColumn="demographicColumn"
        v-bind:demographicColumnNames="demographicColumnNames"
        v-bind:dotDensDemographicColumns="dotDensDemographicColumns"
        v-bind:dotDensDemographicColumn="dotDensDemographicColumn"
        v-bind:dotDensDemographicColumnNames="dotDensDemographicColumnNames"
        v-bind:dotDensDemographicURLs="dotDensDemographicURLs"
        v-bind:bivariateLayersLookup="bivariateLayersLookup"
        v-bind:jobColumns="jobColumns"
        v-bind:jobColumn="jobColumn"
        v-bind:jobColumnNames="jobColumnNames"
        v-bind:startExpanded="startExpanded"
        v-bind:printOnLoad="printOnLoad"
        v-bind:timeFilter="timeFilter"
        v-bind:freeFlow="freeFlow"
        v-bind:bgSummaryLayerOn="bgSummaryLayerOn"
        v-on:set-amenity="mappedAmenity = $event"
        v-on:set-counties="counties = sort($event)"
        v-on:set-mcd="mcd = sort($event)"
        v-on:set-mode="data_table = $event"
        v-on:freeFlow="setDataTables($event)"
        v-on:set-demographic="demographicColumn = $event"
        v-on:set-dot-dens-demographic="dotDensDemographicColumn = $event"
        v-on:set-jobs="jobColumn = $event"
        v-on:time-slider-input="timeFilter = $event"
        v-on:bgSummaryLayerOn="bgSummaryLayerOn = $event"
    />
  </div>
</template>

<script>
import mainmap from "./components/MainMap";
import SemcogHeader from './components/SemcogHeader.vue';

export default {
  name: 'app',
  components: {
    mainmap, SemcogHeader
  },
  data: function () {
    let amenityNames = {
      'hospitals': 'Hospitals',
      'urgent_cares': 'Urgent Care Facilities',
      'health_centers': 'Community Health Centers',
      'all_healthcare': 'Any Healthcare Facility',
      'grocery_stores': 'Grocery Stores',
      'libraries': 'Libraries',
      'parks_vehicle': 'Regional Parks (>100 Acres)',
      'schools_k8': 'Schools K-8',
      'schools_912': 'Schools 9-12',
      'pharmacies': 'Pharmacies',
      'childcare': 'Childcare Facilities',
      'fire_stations': 'Fire Stations',
      'american_job_centers': 'American Job Centers',
      'community_colleges': 'Community Colleges',
      'passenger_airports': 'Passenger Airport (DTW)',
      'passenger_train_stations': 'Passenger Train Stations',
      'parks_local': 'Parks (Local)',
      'parks_bike': 'Regional Parks (>100 Acres)',
      'parks_school': 'Parks (School)',
      'parks_local_school': 'Parks (Local and School)',
      'fixed_route_bus': 'Fixed Route Transit Stops',
      'parks': 'Parks',
    }


    let modeNames = {
      "walk_indicators_demographics_by_parcel": {
        "name": "Walk",
        "breakPoints": [0, 5, 10, 15, 30],
        'colorMap': [
          '#009392',
          '#39b185',
          '#9ccb86',
          '#e9e29c',
          '#ffffff',
        ],
        "interpolateSpeedMinPerKM": 12.43, // 3mph
        "icon": 'walking',
        'url': 'mapbox://semcog.1q6oix7g',
        'sourceName': 'walk_indicators_demographics_by_parcel'
      },
      "bike_indicators_demographics_by_parcel": {
        "name": "Bike",
        "breakPoints": [0, 5, 10, 15, 20, 30],
        'colorMap': [
          '#009392',
          '#39b185',
          '#9ccb86',
          '#e9e29c',
          '#fbf5dc',
          '#ffffff'
        ],
        "interpolateSpeedMinPerKM": 3.728, // 10mph
        "icon": 'biking',
        'url': 'mapbox://semcog.3uqzfg8c',
        'sourceName': 'bike_indicators_demographics_by_parcel'
      },
      "bike_comfort_indicators_demographics_by_parcel": {
        "name": "Bike",
        "breakPoints": [0, 5, 10, 15, 20, 30],
        'colorMap': [
          '#009392',
          '#39b185',
          '#9ccb86',
          '#e9e29c',
          '#fbf5dc',
          '#ffffff'
        ],
        "interpolateSpeedMinPerKM": 3.728, // 10mph
        "icon": 'biking',
        'url': 'mapbox://semcog.96erup3l',
        'sourceName': 'bike_comfort_indicators_demographics_by_parcel'
      },
      "drive_indicators_demographics_by_parcel": {
        "name": "Drive",
        "breakPoints": [0, 10, 15, 30, 45, 60],
        'colorMap': [
          '#009392',
          '#39b185',
          '#9ccb86',
          '#e9e29c',
          '#fbf5dc',
          '#ffffff'
        ],
        "interpolateSpeedMinPerKM": 1.2428, // 30 mph
        "icon": 'car',
        'url': 'mapbox://semcog.68320owh',
        'sourceName': 'drive_indicators_demographics_by_parcel'
      },
      "transit_indicators_demographics_by_parcel": {
        "name": "Transit",
        "breakPoints": [0, 10, 15, 30, 45, 60],
        'colorMap': [
          '#009392',
          '#39b185',
          '#9ccb86',
          '#e9e29c',
          '#fbf5dc',
          '#ffffff'
        ],
        "interpolateSpeedMinPerKM": 12.43, // 3mph
        "icon": 'bus',
        'url': 'mapbox://semcog.13tusoa9',
        'sourceName': 'transit_indicators_demographics_by_parcel'
      },
    };

    let demographicColumns = [
      {value: null, name: 'No Demographic Data Displayed'},
      {value: 'households', name: 'All Households'},
      {value: 'population', name: 'Population'},
      {value: 'hhs_transit_dependent', name: 'Transit-dependent Households'},
      {value: 'hhs_with_seniors', name: 'Households with Seniors'},
      {value: 'hhs_with_children', name: 'Households with Children'},
      {value: 'hhs_low_income', name: 'Low Income Households'},
      {value: 'hhs_with_minority_head', name: 'Minority-Headed Households'},
      {value: 'pop_working_age', name: 'Working Age Population'},
    ];

    let bivariateLayers = [
      {
        value: 'transit_indicators_demographics_by_parcel',
        name: 'block_groups_transit_time_summary',
        url: 'mapbox://semcog.61jn72g7',
        break: 30
      },
      {
        value: 'drive_indicators_demographics_by_parcel',
        name: 'block_groups_drive_time_summary',
        url: 'mapbox://semcog.0v5c1qon',
        break: 10
      },
      {
        value: 'walk_indicators_demographics_by_parcel',
        name: 'block_groups_walk_time_summary',
        url: 'mapbox://semcog.85qe6dyc',
        break: 10
      },
      {
        value: 'bike_indicators_demographics_by_parcel',
        name: 'block_groups_bike_time_summary',
        url: 'mapbox://semcog.cafl7l6p',
        break: 10
      },
      {
        value: 'bike_comfort_indicators_demographics_by_parcel',
        name: 'block_groups_bike_comfort_time_summary',
        url: 'mapbox://semcog.auj03cm9',
        break: 10
      },
    ];

    let dotDensDemographicColumns = [
      {value: null, name: 'No Demographic Data Displayed', url: undefined},
      {value: 'households', name: 'All Households', url: 'mapbox://semcog.5vtnmr4h'},
      {value: 'population', name: 'All Population', url: 'mapbox://semcog.5j1wnqe9'},
      {
        value: 'demographic_emphasis_area',
        name: 'Transportation Access Focus Population Block Groups',
        url: 'mapbox://semcog.3hmh0j8i'
      },
      {value: 'pop_disability', name: 'Population with a Disability', url: 'mapbox://semcog.cvoec36i'},
      {value: 'hhs_in_poverty', name: 'Households in Poverty', url: 'mapbox://semcog.d2r7p8t6'},
      {value: 'hhs_single_parent', name: 'Single-Parent Households', url: 'mapbox://semcog.a9155y56'},
      {value: 'hhs_female_head', name: 'Female-Headed Households', url: 'mapbox://semcog.bv5z3kil'},
      {value: 'hhs_snap', name: 'Households receiving SNAP', url: 'mapbox://semcog.1q2cjzft'},
      {
        value: 'hhs_limited_english',
        name: 'Households with Limited English Proficiency',
        url: 'mapbox://semcog.6wjlh3s6'
      },
    ];

    let qmcd = this.$route.query.mcd;
    let qcounty = this.$route.query.county;

    let county = [];
    if (qcounty) {
      if (Array.isArray(qcounty)) {
        county = qcounty.map(m => {
          return {statevalue: parseInt(m, 10)}
        });
      } else {
        county = [{statevalue: parseInt(qcounty, 10)}]
      }
    }

    let data_tables
    if (this.$route.query.freeflow) {
      data_tables = ['walk_indicators_demographics_by_parcel', 'bike_indicators_demographics_by_parcel', 'transit_indicators_demographics_by_parcel', 'drive_indicators_demographics_by_parcel']
    } else {
      data_tables = ['walk_indicators_demographics_by_parcel', 'bike_comfort_indicators_demographics_by_parcel', 'transit_indicators_demographics_by_parcel', 'drive_indicators_demographics_by_parcel']
    }

    return {
      mappedAmenity: (this.$route.query.amenity) ? this.$route.query.amenity : 'schools_912',
      destLookup: {
        'hospitals': 'hospitals',
        'urgent_cares': 'urgent_cares',
        'health_centers': 'health_centers',
        'all_healthcare': 'all_healthcare',
        'grocery_stores': 'grocery_stores',
        'libraries': 'libraries',
        'parks_vehicle': 'parks_vehicle',
        'schools_k8': 'schools_k8',
        'schools_912': 'schools_912',
        'pharmacies': 'pharmacies',
        'childcare': 'childcare',
        'fire_stations': 'fire_stations',
        'american_job_centers': 'american_job_centers',
        'community_colleges': 'community_colleges',
        'passenger_airports': 'passenger_airports',
        'passenger_train_stations': 'passenger_train_stations',
        'parks_local': 'parks_local',
        'parks_bike': 'parks_bike',
        'parks_school': 'parks_school',
        'parks_local_school': 'parks_local_school',
        'fixed_route_bus': 'fixed_route_bus',
        'parks': 'parks_bike',
      },
      amenityNames,
      startExpanded: Object.keys(this.$route.query).length === 0,
      printOnLoad: this.$route.query.print,
      data_table: (modeNames[this.$route.query.mode]) ? this.$route.query.mode : 'bike_comfort_indicators_demographics_by_parcel',
      data_tables: data_tables,
      freeFlow: this.$route.query.freeflow || false,
      counties: county,
      mcd: (Array.isArray(qmcd) ? qmcd.map(m => parseInt(m, 10)) : parseInt(qmcd, 10)) || 0,
      timeFilter: [0, 100],
      modeNames,
      demographicColumns,
      dotDensDemographicColumns,
      bivariateLayers,
      bgSummaryLayerOn: this.$route.query.bivariate || false,
      demographicColumn: (demographicColumns.map(x => x.value).includes(this.$route.query.demographic) ? this.$route.query.demographic : null),
      dotDensDemographicColumn: (dotDensDemographicColumns.map(x => x.value).includes(this.$route.query.dotdensdemographic) ? this.$route.query.dotdensdemographic : null),
      jobColumn: this.$route.query.jobs || null,
    }
  },
  computed: {
    demographicColumnNames: function () {
      let out = {};
      this.demographicColumns.forEach(x => out[x.value] = x.name);
      return out
    },
    jobColumnNames: function () {
      let out = {};
      this.jobColumns.forEach(x => out[x.value] = x.name);
      return out
    },
    dotDensDemographicColumnNames: function () {
      let out = {};
      this.dotDensDemographicColumns.forEach(x => out[x.value] = x.name);
      return out
    },
    dotDensDemographicURLs: function () {
      let out = {};
      this.dotDensDemographicColumns.forEach(x => out[x.value] = x.url);
      return out
    },
    bivariateLayersLookup: function () {
      let out = {};
      this.bivariateLayers.forEach(x => out[x.value] = x);
      return out
    },
    amenities: function () {
      let transit = ['hospitals', 'urgent_cares', 'health_centers', 'all_healthcare', 'grocery_stores', 'libraries', 'parks_vehicle', 'schools_k8', 'schools_912',
        'pharmacies', 'childcare', 'fire_stations', 'american_job_centers', 'community_colleges', 'passenger_airports', 'passenger_train_stations']
      let bike_comfort = ['hospitals', 'urgent_cares', 'health_centers', 'all_healthcare', 'grocery_stores', 'libraries', 'parks_local_school', 'parks_bike', 'schools_k8',
        'schools_912', 'pharmacies', 'childcare', 'fire_stations', 'fixed_route_bus', 'american_job_centers', 'community_colleges', 'passenger_airports', 'passenger_train_stations']
      let bike = ['hospitals', 'urgent_cares', 'health_centers', 'all_healthcare', 'grocery_stores', 'libraries', 'parks_local_school', 'parks', 'parks_vehicle',
        'schools_k8', 'schools_912', 'pharmacies', 'childcare', 'fire_stations', 'fixed_route_bus', 'american_job_centers', 'community_colleges', 'passenger_airports',
        'passenger_train_stations']
      let walk = ['hospitals', 'urgent_cares', 'health_centers', 'all_healthcare', 'grocery_stores', 'libraries', 'parks_local_school', 'parks_bike',
        'schools_k8', 'schools_912', 'pharmacies', 'childcare', 'fire_stations', 'fixed_route_bus', 'american_job_centers', 'community_colleges', 'passenger_train_stations']
      let drive = ['hospitals', 'urgent_cares', 'health_centers', 'all_healthcare', 'grocery_stores', 'libraries', 'parks_vehicle', 'schools_k8', 'schools_912', 'pharmacies',
        'childcare', 'fire_stations', 'american_job_centers', 'community_colleges', 'passenger_airports', 'passenger_train_stations']

      if (this.data_table === 'walk_indicators_demographics_by_parcel') {
        return walk
      }
      if (this.data_table === 'bike_indicators_demographics_by_parcel') {
        return bike
      }
      if (this.data_table === 'bike_comfort_indicators_demographics_by_parcel') {
        return bike_comfort
      }
      if (this.data_table === 'drive_indicators_demographics_by_parcel') {
        return drive
      }
      if (this.data_table === 'transit_indicators_demographics_by_parcel') {
        return transit
      }
      return drive

    },
    jobColumns: function () {
      if (this.data_table === 'walk_indicators_demographics_by_parcel' || this.data_table === 'bike_indicators_demographics_by_parcel' || this.data_table === 'bike_comfort_indicators_demographics_by_parcel') {
        return [
          {value: null, name: 'No Job Data Displayed'},
          {value: 'jobs_cumulative_5min', name: 'Total Number of Jobs (within 5 Minutes)'},
          {value: 'jobs_cumulative_10min', name: 'Total Number of Jobs (within 10 Minutes)'},
          {value: 'jobs_cumulative_15min', name: 'Total Number of Jobs (within 15 Minutes)'},
          {value: 'jobs_cumulative_30min', name: 'Total Number of Jobs (within 30 Minutes)'},
        ]
      }
      if (this.data_table === 'drive_indicators_demographics_by_parcel') {
        return [
          {value: null, name: 'No Job Data Displayed'},
          {value: 'jobs_cumulative_25min', name: 'Total Number of Jobs (within 25 Minutes)'},
          {value: 'jobs_gravity_90min', name: 'Access to Jobs using Gravity (within 90 Minutes)'},
        ]
      }
      if (this.data_table === 'transit_indicators_demographics_by_parcel') {
        return [
          {value: null, name: 'No Job Data Displayed'},
          {value: 'jobs_cumulative_15min', name: 'Total Number of Jobs (within 15 Minutes)'},
          {value: 'jobs_cumulative_20min', name: 'Total Number of Jobs (within 20 Minutes)'},
          {value: 'jobs_cumulative_30min', name: 'Total Number of Jobs (within 30 Minutes)'},
          {value: 'jobs_cumulative_45min', name: 'Total Number of Jobs (within 45 Minutes)'},
          {value: 'jobs_cumulative_60min', name: 'Total Number of Jobs (within 60 Minutes)'},
          {value: 'jobs_cumulative_90min', name: 'Total Number of Jobs (within 90 Minutes)'},
          {value: 'jobs_gravity_90min', name: 'Access to Jobs using Gravity (within 90 Minutes)'},
        ]
      }

      return [
        {value: null, name: 'No Job Data Displayed'},
      ]
    },
    query: function () {
      let out = {
        amenity: this.mappedAmenity,
        mode: this.data_table,
      };
      if (this.mcd) {
        out.mcd = this.mcd
      }
      if (this.demographicColumn) {
        out.demographic = this.demographicColumn
      }
      if (this.dotDensDemographicColumn) {
        out.dotdensdemographic = this.dotDensDemographicColumn
      }
      if (this.jobColumn) {
        out.jobs = this.jobColumn
      }
      if (this.bgSummaryLayerOn) {
        out.bivariate = this.bgSummaryLayerOn
      }
      if (this.freeFlow) {
        out.freeflow = this.freeFlow
      }
      return out
    },
  },
  methods: {
    sort: function (ids) {
      if (ids.sort) {
        return ids.sort((a, b) => a - b);
      }
      return ids;
    },
    setDataTables: function (free_flow) {
      this.freeFlow = free_flow
      if (free_flow) {
        this.data_tables = ['walk_indicators_demographics_by_parcel', 'bike_indicators_demographics_by_parcel', 'transit_indicators_demographics_by_parcel', 'drive_indicators_demographics_by_parcel']
        this.data_table = 'bike_indicators_demographics_by_parcel'
      } else {
        this.data_tables = ['walk_indicators_demographics_by_parcel', 'bike_comfort_indicators_demographics_by_parcel', 'transit_indicators_demographics_by_parcel', 'drive_indicators_demographics_by_parcel']
        this.data_table = 'bike_comfort_indicators_demographics_by_parcel'
      }
    }
  },
  watch: {
    query: function () {
      if (
          this.$route.query.amenity !== this.mappedAmenity ||
          this.$route.query.mode !== this.data_table ||
          this.$route.query.mcd !== this.mcd ||
          this.$route.query.demographic !== this.demographicColumn ||
          this.$route.query.dotdensdemographic !== this.dotDensDemographicColumn ||
          this.$route.query.jobs !== this.jobColumn ||
          this.$route.query.freeflow !== this.freeFlow
      ) {
        this.$router.replace({
          query: this.query
        })
      }
    },
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-rows: max-content auto;
  font-family: Arial, Helvetica, sans-serif;
}

@media screen and (max-width: 576px) {
  #app {
    height: initial;
  }
}

@media screen {
  .dynamic-title {
    display: none;
  }

  .title {
    display: unset;
  }
}

@media print {
  @page {
    size: landscape;
  }

  .dynamic-title {
    display: unset;
  }

  .title {
    display: none;
  }
}

.my-tooltip {
  display: block !important;
  z-index: 33;
  font-size: small;
  max-width: 90%;
}

.my-tooltip strong {
  font-size: medium;
}

.my-tooltip small {
  color: #9aa5a9;
  font-size: small;
}

.my-tooltip .my-tooltip-inner {
  background: #292424;
  color: white;
  opacity: 0.95;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.my-tooltip .my-tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #292424;
  opacity: 0.95;
  z-index: 33;
}

.my-tooltip[x-placement^="top"] {
  margin-bottom: 10px;
}

.my-tooltip[x-placement^="top"] .my-tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 10px);
  margin-top: 0;
  margin-bottom: 0;
}

.my-tooltip[x-placement^="bottom"] {
  margin-top: 10px;
}

.my-tooltip[x-placement^="bottom"] .my-tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 10px);
  margin-top: 0;
  margin-bottom: 0;
}

.my-tooltip[x-placement^="right"] {
  margin-left: 10px;
}

.my-tooltip[x-placement^="right"] .my-tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.my-tooltip[x-placement^="left"] {
  margin-right: 10px;
}

.my-tooltip[x-placement^="left"] .my-tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.my-tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: #292424;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
}

.my-tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.my-tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.my-tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>
